import { SearchExistingField } from '@skyline-platform/alchemy';
import { getAppliances } from '@utils/graphql/creators/appliances';
import PropTypes from 'prop-types';
import { getLogger } from '@utils/general';
import { getAddrLabel } from '@pages/utils/helpers';

const logger = getLogger('src.components.FormComponents.ApplianceForm.SearchExistingAppliance');

export const SearchExistingAppliance = ({
  fieldName, required = true, ...props
}) => {
  const getAvailableAppliances = async () => {
    const { query, execute } = getAppliances();
    query.addReturnProperties('name', 'id', 'management_address');

    try {
      const res = await execute();
      // Only show the mgmt address for the stream profile source (Appliance),
      // and not the Stream source (Host Appliance)
      if (fieldName === 'Appliance') {
        const normalizedData = res.data.map((appliance) => {
          return {
            ...appliance,
            name: getAddrLabel(appliance, 'management_address'),
          };
        });

        return {
          ...res,
          data: normalizedData,
        };
      } else {
        return res;
      }
    } catch (error) {
      logger.error(error.message);
    }
  };

  return (
    <SearchExistingField
      fieldName={fieldName}
      required={required}
      fetchData={getAvailableAppliances}
      {...props}
    />
  );
};

SearchExistingAppliance.propTypes = {
  fieldName: PropTypes.string.isRequired,
  formData: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  setFormData: PropTypes.func.isRequired,
  required: PropTypes.bool,
};
